import type { BannerPreset } from "@atrium/shared";

/*
 * User-chosen colours (role colours, community banners and accents). These are data,
 * not interface tokens: the UI chrome never uses them, only content a community styles.
 */

export const ROLE_COLOURS = [
  "#5fb6e8",
  "#7c93ff",
  "#a58bff",
  "#e26a9b",
  "#ef7b5b",
  "#e8b04c",
  "#c9d44f",
  "#4cc38a",
  "#3fb8b0",
  "#9ca3af",
] as const;

/** Community accent choices; null means "use the viewer's own accent". */
export const COMMUNITY_ACCENTS = ["#7c93ff", "#a58bff", "#e26a9b", "#ef7b5b", "#e8b04c", "#4cc38a", "#3fb8b0", "#5fb6e8"] as const;

export const BANNER_COLOURS: Record<BannerPreset, string> = {
  graphite: "#3a3a40",
  rose: "#d9468f",
  red: "#d6453d",
  orange: "#e0782f",
  amber: "#d9a62b",
  violet: "#8a5bd6",
  blue: "#2f8fe0",
  teal: "#2fb3a0",
  green: "#4d8a2a",
  slate: "#4a5568",
};

/** Flat fill for a banner preset. */
export function bannerBackground(preset: BannerPreset | null | undefined): string {
  return BANNER_COLOURS[preset ?? "graphite"];
}
